import { useEffect, useRef, useState } from "react";

/**
 * @template T
 * @param {() => Promise<import("axios").AxiosResponse<T>>} apiFunction
 * @param {T?} initialValue
 * @param {React.DependencyList?} dependencies
 * @param {((data: T) => any)?} callback
 * @returns {[T, "loading" | "success" | "error", (value: T | () => T) => void]}
 */
export default function useAxiosData(apiFunction, initialValue, dependencies, callback) {
    const [data, setData] = useState(initialValue);
    const [status, setStatus] = useState("loading");
    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const response = (await apiFunction()).data;
                if (mounted.current) {
                    setData(response);
                    setStatus("success");
                    callback?.(response);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                if (mounted.current) {
                    setStatus("error");
                }
            }
        })();
    }, dependencies ?? []);

    return [data, status, setData];
}